/* PSM redesign — keeps the current product's model-list row and the
 * SKU readout pill live when the variant changes on a combined-listing
 * child page. Pattern mirrors assets/model-option.js.
 * Note: event.detail.variant.inventory may be the string 'none'
 * (see the JSON block in snippets/variant-picker.liquid). */
if (!customElements.get('psm-model-row')) {
  class PsmModelRow extends HTMLElement {
    connectedCallback() {
      const picker = this.closest('.product-info')?.querySelector('variant-picker')
        || this.closest('variant-picker');
      if (picker) picker.addEventListener('on:variant:change', this.onChange.bind(this));
    }

    onChange(evt) {
      const { product, variant, formatted } = evt.detail;
      if (!product || !variant || product.handle !== this.dataset.productHandle) return;
      const sku = this.querySelector('[data-sku]');
      if (sku && variant.sku) sku.textContent = variant.sku;
      const price = this.querySelector('[data-price]');
      if (price && formatted && formatted.price && !price.hasAttribute('data-locked')) price.textContent = formatted.price;
      let inv = parseInt(variant.inventory, 10);
      if (Number.isNaN(inv)) inv = 0;
      const low = parseInt(this.dataset.thresholdLow, 10) || 0;
      const stock = this.querySelector('[data-stock]');
      if (stock) {
        stock.classList.remove('bo', 'low');
        let txt = 'In stock';
        if (inv <= 0) {
          stock.classList.add('bo');
          txt = 'Backorder';
        } else if (inv <= low) {
          stock.classList.add('low');
          txt = 'Low stock';
        }
        const txtEl = stock.querySelector('.ml-stock-txt');
        if (txtEl) txtEl.textContent = txt;
      }
      const readout = document.querySelector('[data-psm-readout]');
      if (readout && variant.sku) {
        // Write the value span (not the pill) so the copy icon survives; keep the
        // copy aria-label in sync. Falls back to the pill itself if no value span.
        const rv = readout.querySelector('[data-psm-readout-value]') || readout;
        rv.textContent = variant.sku;
        if (readout.hasAttribute('data-psm-copyable')) readout.setAttribute('aria-label', 'Copy SKU ' + variant.sku);
      }
    }
  }
  customElements.define('psm-model-row', PsmModelRow);
}
